import { format } from 'date-fns';

export default function toDisplayTimestamp(ts: number) {
  const d = new Date(ts * 1000);
  return format(d, 'MMM d, yyyy hh:mma');
  
  /*
  return d.toLocaleString('en-US', ({
    dateStyle: 'medium',
    hour12: true,
    timeStyle: 'short'
  } as any));
  */
}

